const header__burger = document.querySelector('.header__burger');
const header__mobile = document.querySelector('.header__mobile');

if(!!header__burger && !!header__mobile) {
  header__burger.addEventListener('click', ()=>{
    if(header__burger.classList.contains('active')) {
      header__burger.classList.remove('active');
      header__mobile.classList.remove('active');
    } else {
      header__burger.classList.add('active');
      header__mobile.classList.add('active');
    }
  });
}
